const generateTimeOptions = () => {
  const interval = 15 // Interval in minutes
  const options = []
  let totalMinutes = 0 // Start from 0 minutes

  while (totalMinutes < 1440) {
    // 1440 minutes in a day (24 * 60)
    const hours = String(Math.floor(totalMinutes / 60)).padStart(2, '0')
    const minutes = String(totalMinutes % 60).padStart(2, '0')
    options.push(`${hours}:${minutes}`)
    totalMinutes += interval // Increment by interval
  }

  return options
}

export default generateTimeOptions
